module.exports = __webpack_public_path__ + "static/media/playLogo.fdaf2b4b.png";